<template lang="pug">
div(class="button-select")
    div(class="insety-16")
        ib-button-submit(
            class="xl accent insetx-64",
            :disabled="disabled",
            :class="{primary: isZenith}"
        ) {{ $t('view_results') }}
        ib-button(
            class="reset-filter pointer",
            :class="btnClass",
            @click.prevent="resetFilter"
        ) {{ $t('reset_filters') }}
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'SubmitForm',
        props: ['disabled'],
        data() {
           return {
           }
        },
        computed: {
            ...mapGetters([
                'isZenith'
            ]),

            btnClass() {
                return {
                    'fg-accent': !this.isZenith,
                    'insetx-64': !this.isZenith,
                    'tertiary': this.isZenith,
                    'xl': this.isZenith
                }
            }
        },
        methods: {
            resetFilter() {
                this.$emit('onReset');
            }
        },
 }
</script>

<style lang="less">
.reset-filter {
    background: none;
    border: none;
    &::after {
        background-color: #fff;
    }
    &._btn:active:hover::after {
        background-color: transparent;
        box-shadow: none;
        color: #db1222;
    }
}

@media (max-width: 600px) {
    .button-select {
        button {
            display: block;
            margin: 6px auto;
        }
    }
}
</style>
